import React, { Ref, forwardRef } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn, { IFlexColumn } from '@ui/atoms/FlexColumn';
import FlexRow, { IFlexRow } from '@ui/atoms/FlexRow';

import RadioButton, { IRadioButtonProps } from '@ui/forms/RadioButton';

import AddressText from '@ui/molecules/AddressText';

import aligned from '@ui/styled/Aligned';
import fullWidth from '@ui/styled/FullWidth';

import { IPharmacyAddress } from '@folx-types/pharmacy';

interface ILocationOptionProps extends IPharmacyAddress {
	radioProps: IRadioButtonProps;
}

const AlignedRow = aligned<IFlexRow>(FlexRow);
const FullWidthColumn = fullWidth<IFlexColumn>(FlexColumn);

const LocationRadio = styled(RadioButton)`
	width: 100%;
	& > span {
		width: 100%;
		align-items: flex-start;
	}
`;

const LocationOption = forwardRef<HTMLInputElement, ILocationOptionProps>(
	({ address, city, distanceMiles, name, state, zip, radioProps }, ref) => {
		return (
			<FlexRow gap="sm">
				<LocationRadio {...radioProps} ref={ref}>
					<FullWidthColumn gap="xxs">
						<BasicText>{name}</BasicText>
						<AlignedRow alignItems="flex-end" justifyContent="space-between" gap="sm">
							<AddressText
								variant="fineprint"
								address={address}
								city={city}
								state={state}
								zip={zip}
							/>
							<BasicText variant="fineprint">{distanceMiles} mi away</BasicText>
						</AlignedRow>
					</FullWidthColumn>
				</LocationRadio>
			</FlexRow>
		);
	}
);
LocationOption.displayName = 'LocationOption';

export default styled(LocationOption)``;
